import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import Link from '@components/link/Link.tsx';
import getEndText from '@functions/getEndText.ts';
import getFormatedDate from '@functions/getFormatedDate.ts';
import setSpacesInText from '@functions/setSpacesInText.ts';

import I from '../types.ts';

const renderContent: I['renderContent'] = function () {
    const article = this.state.article!;
    const { device } = this.props;
    const imageSrc = article.preview.fullSrc;

    return (
        <div className="publicBlogInner__content _col">
            <Link
                className="publicBlogInner__back _row"
                pageName="public-blog-inner"
                ids={{ 2: article.sectionId! }}
            >
                <i className="publicBlogInner__backIcon">
                    <Icon name="arrow-prev-2" />
                </i>
                Назад
            </Link>
            <div className="publicBlogInner__contentInner">
                {device === 'mobile' && (
                    <div className="publicBlogInner__head _mob _row">
                        <div className="publicBlogInner__headInfo _row _left">
                            <i className="publicBlogInner__headInfoIcon">
                                <Icon name="blog-view" />
                            </i>
                            {article?.viewCounter || 0}
                        </div>
                    </div>
                )}
                <div className="publicBlogInner__head _row">
                    <div className="publicBlogInner__headInfo _row">
                        {getFormatedDate({
                            date: new Date(article?.createdDate),
                            type: 'yearText',
                        })}
                    </div>
                    {device === 'desktop' && (
                        <>
                            <div className="publicBlogInner__headInfo _time _row">
                                <i className="publicBlogInner__headInfoIcon">
                                    <Icon name="blog-time" />
                                </i>
                                {article?.time}{' '}
                                {getEndText(article?.time, ['минута', 'минуты', 'минут'])}
                            </div>
                        </>
                    )}

                    <div className="publicBlogInner__headInfo _row">{article?.sectionText}</div>
                    {device === 'desktop' && (
                        <>
                            <div className="publicBlogInner__headInfo _row _left">
                                <i className="publicBlogInner__headInfoIcon">
                                    <Icon name="blog-view" />
                                </i>
                                {article?.viewCounter || 0}
                            </div>
                        </>
                    )}
                </div>
                <div className="publicBlogInner__article">
                    <h1
                        className="publicBlogInner__articleTitle"
                        dangerouslySetInnerHTML={{
                            __html: setSpacesInText(article?.title),
                        }}
                    ></h1>
                    {device === 'mobile' && (
                        <>
                            <div className="publicBlogInner__headInfo _time _row">
                                <i className="publicBlogInner__headInfoIcon">
                                    <Icon name="blog-time" />
                                </i>
                                {article?.time}{' '}
                                {getEndText(article?.time, ['минута', 'минуты', 'минут'])}
                            </div>
                        </>
                    )}
                    <img src={imageSrc} alt="" className="publicBlogInner__articleImage" />
                    <div
                        className="publicBlogInner__articleInner"
                        dangerouslySetInnerHTML={{
                            __html: setSpacesInText(article?.content),
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default renderContent;
